import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { chooseNewApp, newAppUrl } from '@core/new-app-switch';

@Component({
  standalone: true,
  selector: 'app-new-app-banner',
  imports: [NgIf],
  template: `
    <div *ngIf="url" class="new-app-banner">
      <span>A new version of INSCYD is available</span>
      <a [href]="url" (click)="onSwitch()">Try the new INSCYD &rarr;</a>
    </div>
  `,
  styles: [
    `
      .new-app-banner {
        position: fixed;
        top: 8px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2147483647;
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 6px 6px 6px 16px;
        border-radius: 999px;
        background: #1b1f3b;
        border: 1px solid rgba(255, 255, 255, 0.12);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
        color: #fff;
        font-size: 13px;
        white-space: nowrap;
      }

      a {
        padding: 6px 14px;
        border-radius: 999px;
        background: #fff;
        color: #1b1f3b;
        font-weight: 600;
        text-decoration: none;
      }

      a:hover {
        background: #e8e9f0;
      }
    `,
  ],
})
export class NewAppBannerComponent {
  public readonly url: string | null = newAppUrl;

  public onSwitch(): void {
    chooseNewApp();
  }
}
